// 后台 cv 来的

import { request } from "@umijs/max";

/**
 * 收支类型
 */
export enum IncomeAndExpenditureTypeEnum {
  INCOME = "INCOME", // 收入
  EXPENDITURE = "EXPEND", // 支出
}

/**
 * 交易类型
 */
export enum TransactionTypeEnum {
  CONSUMPTION = "CONSUME", // 消费
  RECHARGE = "RECHARGE", // 充值
}

/**
 * 交易渠道
 */
export enum TradingChannelsEnum {
  BALANCE = "BALANCE", // 余额
  OFFLINE_BANK_CARD = "OFFLINE", // 线下银行卡
  WECHAT = "WECHAT",
  ALIPAY = "ALIPAY",
}

/**
 * 收支订单状态
 */
export enum IncomeAndExpenditureOrderStatusEnum {
  COMPLETED = "DONE", // 已生效
  PENDING = "PAYING", // 审核中
}

/**
 * 财务审批状态
 */
export enum IncomeAndExpenditureOrderFinanceApprovalStatusEnum {
  // 待审批
  PENDING = "WAIT",
  // 审批通过
  APPROVED = "PASS",
}

interface IIncomeAndExpenditureData {
  pageNum: number;
  pageSize: number;
  startTime: string;
  endTime: string;
  /** 交易类型 */
  changeType: `${TransactionTypeEnum}`;
  /** 收支类型 */
  transType: `${IncomeAndExpenditureTypeEnum}`;
}

interface IPagnation<T> {
  current: number;
  pages: number;
  size: number;
  total: number;
  records: T[];
}

interface IIncomeAndExpenditureDetail {
  approvalStatus: `${IncomeAndExpenditureOrderFinanceApprovalStatusEnum}`;
  billId: string;
  billStartTime: string;
  /** 账期 */
  billTime: string;
  cashBalance: number;
  /** 交易类型 */
  changeType: `${TransactionTypeEnum}`;
  giftAmount: number; // 赠送金额
  giftBalance: number;
  /** 实付金额 */
  payAmount: number;
  payId: string;
  payNo: string;
  // payStatus:
  payTime: string;
  payType: `${TradingChannelsEnum}`;
  tenantId: string;
  thirdAccount: string;
  thirdPayNo: string;
  totalBalance: number;
  transType: `${IncomeAndExpenditureTypeEnum}`;
  userName: string;
}

/**
 * 获取收支明细
 * @returns
 */
export const postIncomeAndExpenditureDetails = (
  data: Partial<IIncomeAndExpenditureData>
) => {
  return request<API.BaseResponse<IPagnation<IIncomeAndExpenditureDetail>>>(
    "/api/damselfish-fee-center/userSearch/payInfoPage",
    {
      method: "POST",
      data,
    }
  );
};

/**
 * 导出收支明细 url
 * @param data
 * @returns
 */
export const getExportIncomeAndExpenditureDetailsUrl = (
  data: Partial<IIncomeAndExpenditureData>
) => {
  const queryStr = Object.entries(data)
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
  return `/api/damselfish-fee-center/userSearch/payInfoPage/export?${queryStr}`;
};
